import React, { createContext, useState } from "react";

const GlobalContext = createContext({});

const tempDb = {
  afcBournemouth: {
    imageUrl: "./crests/AFC_Bournemouth.svg.png",
    greyscaleImage: "./crests/AFC_Bournemouth_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/AFC_Bournemouth",
    clubName: "A.F.C. Bournemouth",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Bournemouth",
    yearFounded: 1899,
    notablePlayers: "Luis Sinisterra, Enes Unal, Justin Kluivert",
    nickname: "The Cherries",
    mainColors: "red, white, and black",
    lastUsed: new Date().now,
  },
  arsenal: {
    imageUrl: "./crests/Arsenal_FC.svg.png",
    greyscaleImage: "./crests/Arsenal_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Arsenal_F.C.",
    clubName: "Arsenal F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1886,
    notablePlayers: "Martin Odegaard, Riccardo Calafiori, Bukayo Saka",
    nickname: "The Gunners",
    mainColors: "red and blue",
    lastUsed: new Date().now,
  },
  astonVilla: {
    imageUrl: "./crests/Aston_Villa_FC.svg.png",
    greyscaleImage: "./crests/Aston_Villa_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Aston_Villa_F.C.",
    clubName: "Aston Villa",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Birmingham",
    yearFounded: 1874,
    notablePlayers: "Billy Walker, Brian Little, Andy Gray",
    nickname: "The Villans, The Lions",
    mainColors: "blue and yellow",
    lastUsed: new Date().now,
  },
  brentford: {
    imageUrl: "./crests/Brentford_FC.svg.png",
    greyscaleImage: "./crests/Brentford_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Brentford_F.C.",
    clubName: "Brentford",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1889,
    notablePlayers: "Ivan Toney, Yoane Wissa, Igor Thiago",
    nickname: "The Bees",
    mainColors: "red and white",
    lastUsed: new Date().now,
  },
  brightonAndHoveAlbion: {
    imageUrl: "./crests/Brighton_and_Hove_Albion_FC.svg.png",
    greyscaleImage: "./crests/Brighton_and_Hove_Albion_FC_greyscale.svg.png",
    wikipediaLink:
      "https://en.wikipedia.org/wiki/Brighton_%26_Hove_Albion_F.C.",
    clubName: "Brighton & Hove Albion",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Brighton",
    yearFounded: 1901,
    notablePlayers: "Kaoru Mitoma, Bart Verbruggen, Valentin Barco",
    nickname: "The Albion, The Seagulls",
    mainColors: "blue and white",
    lastUsed: new Date().now,
  },
  chelseaFc: {
    imageUrl: "./crests/Chelsea_FC.svg.png",
    greyscaleImage: "./crests/Chelsea_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Chelsea_F.C.",
    clubName: "Chelsea F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1905,
    notablePlayers: "Raheem Sterling, Enzo Fernandez, Christopher Nkunku",
    nickname: "The Blues",
    mainColors: "blue",
    lastUsed: new Date().now,
  },
  crystalPalaceFc: {
    imageUrl: "./crests/Crystal_Palace_FC.svg.png",
    greyscaleImage: "./crests/Crystal_Palace_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Crystal_Palace_F.C.",
    clubName: "Crystal Palace F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1905,
    notablePlayers: "Eberechi Eze, Marc Guehi, Cheick Doucoure",
    nickname: "The Eagles",
    mainColors: "red and blue",
    lastUsed: new Date().now,
  },
  evertonFc: {
    imageUrl: "./crests/Everton_FC.svg.png",
    greyscaleImage: "./crests/Everton_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Everton_F.C.",
    clubName: "Everton F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Liverpool",
    yearFounded: 1878,
    notablePlayers: "Dominic Calvert-Lewin, Ashley Young, Amadou Onana",
    nickname: "The Toffees",
    mainColors: "blue",
    lastUsed: new Date().now,
  },
  fulhamFc: {
    imageUrl: "./crests/Fulham_FC.svg.png",
    greyscaleImage: "./crests/Fulham_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Fulham_F.C.",
    clubName: "Fulham F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1879,
    notablePlayers: "Andreas Pereira, Kenny Tete, Issa Diop",
    nickname: "The Cottagers",
    mainColors: "white and black",
    lastUsed: new Date().now,
  },
  ipswichTownFc: {
    imageUrl: "./crests/Ipswich_Town.svg.png",
    greyscaleImage: "./crests/Ipswich_Town_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Ipswich_Town_F.C.",
    clubName: "Ipswich Town F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Ipswich",
    yearFounded: 1878,
    notablePlayers: "Conor Chaplin, Nathan Broadhead, Massimo Luongo",
    nickname: "The Tractor Boys",
    mainColors: "blue and white",
    lastUsed: new Date().now,
  },
  leicesterCityFc: {
    imageUrl: "./crests/Leicester_City.svg.png",
    greyscaleImage: "./crests/Leicester_City_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Leicester_City_F.C.",
    clubName: "Leicester City F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Leicester",
    yearFounded: 1884,
    notablePlayers: "Jamie Vardy, Harry Winks, Kiernan Dewsbury-Hall",
    nickname: "The Foxes",
    mainColors: "blue and white",
    lastUsed: new Date().now,
  },
  liverpoolFc: {
    imageUrl: "./crests/Liverpool_FC.svg.png",
    greyscaleImage: "./crests/Liverpool_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Liverpool_F.C.",
    clubName: "Liverpool F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Liverpool",
    yearFounded: 1892,
    notablePlayers: "Mohamed Salah, Virgil van Dijk, Alisson Becker",
    nickname: "The Reds",
    mainColors: "red",
    lastUsed: new Date().now,
  },
  manchesterCityFc: {
    imageUrl: "./crests/Manchester_City_FC.svg.png",
    greyscaleImage: "./crests/Manchester_City_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Manchester_City_F.C.",
    clubName: "Manchester City F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Manchester",
    yearFounded: 1880,
    notablePlayers: "Erling Haaland, Kevin De Bruyne, Phil Foden",
    nickname: "The Citizens",
    mainColors: "sky blue",
    lastUsed: new Date().now,
  },
  manchesterUnitedFc: {
    imageUrl: "./crests/Manchester_United_FC.svg.png",
    greyscaleImage: "./crests/Manchester_United_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Manchester_United_F.C.",
    clubName: "Manchester United F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Manchester",
    yearFounded: 1878,
    notablePlayers: "Bruno Fernandes, Marcus Rashford, Casemiro",
    nickname: "The Red Devils",
    mainColors: "red, white, and black",
    lastUsed: new Date().now,
  },
  newcastleUnitedFc: {
    imageUrl: "./crests/Newcastle_United.svg.png",
    greyscaleImage: "./crests/Newcastle_United_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Newcastle_United_F.C.",
    clubName: "Newcastle United F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Newcastle upon Tyne",
    yearFounded: 1892,
    notablePlayers: "Kieran Trippier, Bruno Guimarães, Callum Wilson",
    nickname: "The Magpies",
    mainColors: "black and white",
    lastUsed: new Date().now,
  },
  nottinghamForestFc: {
    imageUrl: "./crests/Nottingham_Forest_F.C.svg.png",
    greyscaleImage: "./crests/Nottingham_Forest_F.C_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Nottingham_Forest_F.C.",
    clubName: "Nottingham Forest F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Nottingham",
    yearFounded: 1865,
    notablePlayers: "Brennan Johnson, Morgan Gibbs-White, Taiwo Awoniyi",
    nickname: "The Reds",
    mainColors: "red and white",
    lastUsed: new Date().now,
  },
  southamptonFc: {
    imageUrl: "./crests/Southampton.svg.png",
    greyscaleImage: "./crests/Southampton_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Southampton_F.C.",
    clubName: "Southampton F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Southampton",
    yearFounded: 1885,
    notablePlayers: "James Ward-Prowse, Ché Adams, Kyle Walker-Peters",
    nickname: "The Saints",
    mainColors: "red and white",
    lastUsed: new Date().now,
  },
  tottenhamHotspurFc: {
    imageUrl: "./crests/Tottenham_Hotspur.svg.png",
    greyscaleImage: "./crests/Tottenham_Hotspur_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Tottenham_Hotspur_F.C.",
    clubName: "Tottenham Hotspur F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1882,
    notablePlayers: "Harry Kane, Son Heung-min, James Maddison",
    nickname: "Spurs",
    mainColors: "white and navy blue",
    lastUsed: new Date().now,
  },
  westHamUnitedFc: {
    imageUrl: "./crests/West_Ham_United_FC.svg.png",
    greyscaleImage: "./crests/West_Ham_United_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/West_Ham_United_F.C.",
    clubName: "West Ham United F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "London",
    yearFounded: 1895,
    notablePlayers: "Declan Rice, Jarrod Bowen, Lucas Paquetá",
    nickname: "The Hammers",
    mainColors: "claret and blue",
    lastUsed: new Date().now,
  },
  wolverhamptonWanderersFc: {
    imageUrl: "./crests/Wolverhampton_Wanderers_FC.svg.png",
    greyscaleImage: "./crests/Wolverhampton_Wanderers_FC_greyscale.svg.png",
    wikipediaLink: "https://en.wikipedia.org/wiki/Wolverhampton_Wanderers_F.C.",
    clubName: "Wolverhampton Wanderers F.C.",
    hint1: "first hint. should not reveal a lot",
    hint2: "second hint. should reveal more",
    hint3: "third hint. should reveal more",
    hint4: "fourth hint. should reveal more",
    location: "Wolverhampton",
    yearFounded: 1877,
    notablePlayers: "Rúben Neves, Raúl Jiménez, Pedro Neto",
    nickname: "Wolves",
    mainColors: "gold and black",
    lastUsed: new Date().now,
  },
};

const GlobalContextProvider = ({ children }) => {
  const randomIndex = Math.floor(Math.random() * Object.keys(tempDb).length);

  const [answeredCorrectly, setAnsweredCorrectly] = useState(false);
  const [maxGuessesUsed, setMaxGuessesUsed] = useState(false);

  const [globalContext, setGlobalContext] = useState({
    currentCrest: tempDb[Object.keys(tempDb)[randomIndex]],
  });

  return (
    <GlobalContext.Provider
      value={{
        globalContext,
        setGlobalContext,
        answeredCorrectly,
        setAnsweredCorrectly,
        maxGuessesUsed,
        setMaxGuessesUsed,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalContextProvider };
